export const nbsp = '\u00A0';
export const zeroWidthSpace = '\u200B';
export const FTE_MAX_VALUE = 1;

const secondsInMinute = 60;
export const millisecondsInSecond = 1000;
export const millisecondsInMinute = secondsInMinute * millisecondsInSecond;

export const textInputDebounceTimeout = 300;
